export default __webpack_public_path__ + "static/media/23_1_0.ab186194.png";